export default "__VITE_ASSET__xS5u25c9__"